export enum ButtonTypes {
  Primary = 'primary',
  Success = 'success',
  Warn = 'warn',
  Info = 'info',
  TransparentGrayText = 'transparent-gray-text',
  TransparentWhiteText = 'transparent-white-text',
  White = 'white'
}
